import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';

interface ITextFieldProps {
  onChange: (newValue: string) => void;
  initialValue?: string;
  placeholder: string;
  fieldNumber?: string;
}

export const StyledTextFieldContainer = styled.div`
  position: relative;
  margin-bottom: 20px;
  display: flex;
  flex-direction: row;
  background-color: #E1E8ED;
  align-items: center;
`

export const StyledPlanActivityTextField = styled.input`
  width: 100%;
  height: 45px;
  border: none;
  background-color: #E1E8ED;
  padding: 10px;
`

export const StyledFieldNumber = styled.p`
  margin: 0;
  padding: 10px;
`

export const PlanActivityTextField: React.FC<ITextFieldProps> = ({ initialValue, fieldNumber, placeholder = '', onChange, ...rest }) => {
  const [value, setValue] = useState(initialValue || '');
  const inputRef: React.RefObject<HTMLInputElement> = useRef(null);

  useEffect(() => {
    setValue(initialValue || '');
  }, [initialValue]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const newValue = e.target.value;
    setValue(newValue);
    onChange(newValue);
  };

  return (
    <StyledTextFieldContainer {...rest}>
      {fieldNumber && 
        <StyledFieldNumber>
          {fieldNumber}
        </StyledFieldNumber>
      }
      <StyledPlanActivityTextField
        value={value}
        inputMode={'text'}
        onChange={handleChange}
        placeholder={placeholder}
        ref={inputRef}
      />
    </StyledTextFieldContainer>
  );
};
